<!-- 模板 -->
<template>
  <div :class="[{'qc-container card-box': showBg}]" >
    <div class="card-title">
      <template v-if="title">
        {{title}}<span>{{subTitle}}</span>
      </template>
      <div v-if="showReturn" @click="returnLast()" class="return-box">
        <i class="iconfont el-erptuihui"></i>
        返回
      </div>
      <slot name="title-right"></slot>
    </div>
    <div class="line" :style="{height:'10px'}" v-if="!showDivider"></div>
    <el-tabs v-if="tabList&&tabList.length>0" :tab-position="tabPosition" v-model="activeName" @tab-click="changeTab">
      <el-tab-pane
        v-for="(item,index) in tabList"
        :label="item"
        :name="index"
      ></el-tab-pane>
    </el-tabs>
    <el-divider v-if="showDivider"></el-divider>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      //主标题
      title: String,
      //子标题
      subTitle: String,
      //显示分割线
      showDivider:Boolean,
      //字符串数组["佣金明细","提现记录"]
      tabList:Array,
      activeIndex:{
        type:Number,
        default:0
      },
      //显示返回按钮
      showReturn:Boolean,
      showBg:{
        type:Boolean,
        default:true,
      }
    },
    name: "qc-container",
    data() {
      return {
        activeName:0,
      }
    },
    mixins: [tableBase],
    methods: {
      changeTab(item){
        this.$emit('changeTab', item.index);
      }
    },
    mounted() {
    }
  }
</script>

<style lang="less" scoped>
.return-box{
  float: right;
  cursor: pointer;
  color: @primary;
  font-size: 14px;
  font-weight: normal;
  &:hover{
    opacity: 0.8;
  }
  i{
    font-size: 14px;
  }
}
</style>
